import { get, total as _total, paginate as _paginate } from '@kit/utils/APIV1.js'

export const paginate = async(sortField, cast, direction, page, numberPerPage) => {
  return _paginate('court-documents', sortField, cast, direction, page, numberPerPage)
}
export const total = async() => {
  return _total('court-documents')
}
export const page = async() => {
  return get("tribal-court-page")
}
